import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getAllPackages = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/api/packages`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllPackages:", error);
      reject(error);
    }
  });
};
export const getAllPackagesByPrinciple = async (principleName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/packages/principle/${principleName}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllPackages:", error);
      reject(error);
    }
  });
};
export const getAllCityByPrinciple = async (principleName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/city-package-mapping/${principleName}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllPackages:", error);
      reject(error);
    }
  });
};

export const getAllCorporationByCity = async (cityName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/corporation-city-mapping/${cityName}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllCorporation:", error);
      reject(error);
    }
  });
};
export const getAllPackagesByPrincipleAndCity = async (
  principleName,
  cityname
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/city-package-mapping/${principleName}/${cityname}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllPackagesByPrincipleAndCity:", error);
      reject(error);
    }
  });
};
export const getPackageByPrincipleAndPackageName = async (
  principleName,
  packageName
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/packages/${principleName}/${packageName}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getPackageByPrincipleAndPackageName:", error);
      reject(error);
    }
  });
};
